var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"restock",style:({ zIndex: _vm.zIndexNum })},[_c('div',{staticClass:"restock-text"},[_vm._v(_vm._s(_vm.getDFLANG()?'Restock': '补货中'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }